import * as yup from 'yup';
import { Row, RenderConfig, TextInput, NumberInput } from 'commons-ui';

export const FORM_FIELD_KEYS = {
	SEGMENT_NAME: 'segmentName',
	CASHBACK_UTIL_PER: 'cashbackUtil',
	BONUS_UTIL_PER: 'bonusUtil'
};

export const validationCreateSchema = yup.object().shape({
	segmentName: yup.string().required('Segment Name is a required field'),
	cashbackUtil: yup.number().min(0).max(100).required('Cashback Util % is a required field'),
	bonusUtil: yup.number().min(0).max(100).required('Bonus Util % is a required field')
});

export const validationEditSchema = yup.object().shape({
	cashbackUtil: yup.number().min(0).max(100).required('Cashback Util % is a required field'),
	bonusUtil: yup.number().min(0).max(100).required('Bonus Util % is a required field')
});

export const FORM_FIELD_CONFIG = {
	[FORM_FIELD_KEYS.SEGMENT_NAME]: new RenderConfig()
		.setName('segmentName')
		.setLabel('Segment Name')
		.setRenderer(TextInput)
		.setRenderProps({ isEditable: { create: true, edit: false }, required: true }),
	[FORM_FIELD_KEYS.CASHBACK_UTIL_PER]: new RenderConfig()
		.setName('cashbackUtil')
		.setLabel('Cashback Util %')
		.setRenderer(NumberInput)
		.setRenderProps({ isEditable: { create: true, edit: true }, required: true }),
	[FORM_FIELD_KEYS.BONUS_UTIL_PER]: new RenderConfig()
		.setName('bonusUtil')
		.setLabel('Bonus Util %')
		.setRenderer(NumberInput)
		.setRenderProps({ isEditable: { create: true, edit: true }, required: true })
};

export const FORM_LAYOUT_CONFIG = [
	new Row(FORM_FIELD_KEYS.SEGMENT_NAME),
	new Row(FORM_FIELD_KEYS.BONUS_UTIL_PER),
	new Row(FORM_FIELD_KEYS.CASHBACK_UTIL_PER)
];
